export default __webpack_public_path__ + "static/media/safari-desktop-1.90b5382b.png";